<template>
  <ItemsTable
    :headers="headers"
    :rows="rows"
    :get-data="getData"
    :has-more-data="hasMoreData"
    :is-loading="isLoading"
    :no-items-text="'No shipments found'"
    @clickRow="clickRow"
  />
</template>
<script>
import { routeNames, alertIcons } from '../../../constants';
import ItemsTable from '../table/items-table';
import { facilities as demoFacilities, shipments as demoShipments } from '../../../data/shipments-demo';
import { formatDate } from '../../../mixins/date-time-helper';

export default {
  name: 'ShipmentsTable',
  components: {
    ItemsTable,
  },
  props: {
    selectedId: { type: String, default: null },
    itemIds: { type: Array, default: () => [] },
  },
  computed: {
    isShipmentsDemo() { return this.$root.workspaceFeatures.shipmentsDemo; },
    hasMoreData() { return this.$store.getters['shipments/hasMoreShipments']; },
    isLoading() { return this.$store.state.shipments.isLoadingShipments; },
    headers() {
      const headers = [
        { name: 'Tracking Ref', key: 'trackingRef' },
        { name: 'Asset count', key: 'pieceCount' },
        { name: 'Origin', key: 'origin' },
        { name: 'Destination', key: 'destination' },
      ];

      if (this.isShipmentsDemo) {
        headers.push(...[
          { name: 'ETA', key: 'eta' },
          { name: 'Status', key: 'status' },
        ]);
      }

      return headers;
    },
    shipments() {
      if (this.isShipmentsDemo) {
        return demoShipments;
      }

      return this.$store.state.shipments.shipments;
    },
    rows() {
      const rows = this.shipments
        .filter(({ id }) => this.itemIds.length === 0 || this.itemIds.includes(id))
        .map(({
          id, trackingRef, pieceCount, origin, originName, destination, destinationName, alerts,
        }) => ({
          isSelected: this.selectedId && this.selectedId === id,
          id,
          trackingRef,
          pieceCount,
          origin: this.isShipmentsDemo
            ? demoFacilities.find((facility) => facility.id === origin.where.facility.id).name
            : originName,
          destination: this.isShipmentsDemo
            ? demoFacilities
              .find((facility) => facility.id === destination.where.facility.id).name
            : destinationName,
          etaTimestamp: destination && destination.when && destination.when.estimated
            ? new Date(destination.when.estimated).getTime()
            : 0,
          eta: this.isShipmentsDemo && destination.when && destination.when.estimated
            ? formatDate(new Date(destination.when.estimated), true)
            : '',
          status: {
            value: alerts && alerts.length > 0 ? alerts[0].message : 'OK',
            icon: alerts && alerts.length > 0 ? alertIcons[alerts[0].category][alerts[0].type] : '',
            iconColor: 'warning',
          },
        })).sort((a, b) => a.etaTimestamp - b.etaTimestamp);

      return rows;
    },
  },
  methods: {
    clickRow(row) {
      this.$router.push({
        name: routeNames.shipments.detail,
        params: { id: row.id },
        query: this.$route.query,
      }).catch(() => {
        // duplicate navigation to same facility - do nothing
      });
    },
    getData() {
      if (this.hasMoreData) {
        return this.$store.dispatch('shipments/getShipments');
      }

      return null;
    },
  },
};
</script>
